// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const MY_PRODUCT_NO_REVIEW = "Zat\u00edm nehodnotila";
export const MY_PRODUCT_REVIEW_WAITING_FOR_APPROVE = "\u010cek\u00e1 na schv\u00e1len\u00ed";
export const REMOVE_FROM_PROFILE = "Odeber z profilu";
export const STROLLER_ADD_REVIEW = "P\u0159idej hodnocen\u00ed";
export const USER_STROLLERS_MY_REVIEW = "Moje hodnocen\u00ed";
